export const ADD_FLEET_NOTIFICATION = 'ADD_FLEET_NOTIFICATION'
export const REMOVE_FLEET_NOTIFICATION = 'REMOVE_FLEET_NOTIFICATION'
export const ADD_DELIVERY_NOTIFICATION = 'ADD_DELIVERY_NOTIFICATION'
export const REMOVE_DELIVERY_NOTIFICATION = 'REMOVE_DELIVERY_NOTIFICATION'

export function addFleetNotification(fleet_id) {
  return {
    type: ADD_FLEET_NOTIFICATION,
    fleet_id,
  }
}

export function removeFleetNotification(fleet_id) {
  return {
    type: REMOVE_FLEET_NOTIFICATION,
    fleet_id,
  }
}

export function addDeliveryNotification(delivery_id) {
  return {
    type: ADD_DELIVERY_NOTIFICATION,
    delivery_id,
  }
}

export function removeDeliveryNotification(delivery_id) {
  return {
    type: REMOVE_DELIVERY_NOTIFICATION,
    delivery_id,
  }
}
